import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Dashboard appearance preference. Only ever applied while authenticated —
 * see `hooks/useThemeSync.js`. Logged-out pages always render light
 * regardless of what's stored here.
 */
export const useThemeStore = create(
  persist(
    (set, get) => ({
      theme: 'light',
      toggleTheme: () => set({ theme: get().theme === 'dark' ? 'light' : 'dark' }),
      setTheme: (theme) => set({ theme }),
    }),
    { name: 'mdu-theme' },
  ),
);
